import React, { useEffect, useState } from 'react'
import { useDispatch } from "react-redux";
import CommonDivWidget from 'components/CommonDivWidget/CommonDivWidget'
import { message, Spin, DatePicker, Row, Col } from 'antd';
import CommonButton from 'components/ButtonWidgets/CommonButton/CommonButton';
import { TitleSearch } from 'components/SearchWidget/TitleSearch';
import { useHistory, useParams } from 'react-router-dom';
import { UpdateCurrentRoot } from 'redux/actions/appActions';
import TableWidget from './TableWidget/TableWidget';
import { ROUTE_USER_MAIN_SUB_ITEM_LIST } from 'navigation/CONSTANTS';
import { showAddSubCategoryDialog } from './AddSubCategoryDialog/showAddSubCategoryDialog';
import { apiCreateSubCategory, apiDeleteSubCategory, apiGetSubCategoryList, apiUpdateSubCategory } from 'services/userSiteSubCategoryService';
const { RangePicker } = DatePicker;

function U_SubCategoryPage() {
    const { main_category_id } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const [isBusy, setIsBusy] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [searchList, setSearchList] = useState([]);

    useEffect(() => {
        setIsBusy(true)
        apiGetSubCategoryList(main_category_id)
        .then((data) => {
            setSearchList(data)
            setDataList(data)
            setIsBusy(false)
        })
        .catch((err) => {
            setIsBusy(false)
            // message.error("Sorry! " + err);
        });
    }, []);

    const handleSearch = (searchText) => {
        const tmpList = dataList.filter((info) => info.name.toLowerCase().includes(searchText.toLowerCase()))
        setSearchList([...tmpList])
    };
    const handleChange = (event) => {
        if (event.target.value === "") {
            setSearchList(dataList)
        }
        else {
            handleSearch(event.target.value)
        }
    };
    const onNewSubCategory = async () => {
        var res = await showAddSubCategoryDialog({
            title: "New Sub Category For User Site",
            isEditing: false
        });
        if (res === null) return;
        setIsBusy(true)
        apiCreateSubCategory(res, main_category_id)
            .then((data) => {
                setIsBusy(false);
                if (data === null) {
                    message.error("There's something wrong while adding New Sub Category");
                }
                var tmpData = dataList;
                let updateData = [...dataList];
                updateData.splice(tmpData.length, 0, data);
                tmpData = [...updateData];
                setDataList(tmpData)
                setSearchList(tmpData)
            })
            .catch((err) => {
                setIsBusy(false);
                message.error("Error! " + err);
            });
    }
    const onClickDelete = (pInfo) => {
        setIsBusy(true);
        apiDeleteSubCategory(pInfo.id)
            .then((data) => {
                setIsBusy(false);
                let updateData = [...dataList]
                var storeIndex = updateData.findIndex(x => x.id == pInfo.id);
                updateData.splice(storeIndex, 1);
                var tmpData = [...updateData];
                setDataList(tmpData);
                setSearchList(tmpData);
            })
            .catch((err) => {
                setIsBusy(false);
                message.error(err);
            });
    }
    const onClickDetail = (pInfo) => {
        dispatch(UpdateCurrentRoot({ currentRoute: ROUTE_USER_MAIN_SUB_ITEM_LIST }))
        history.push(ROUTE_USER_MAIN_SUB_ITEM_LIST + "/" + main_category_id + "/" + pInfo.id)
    }
    const onClickEdit = async (pInfo) => {
        let info = pInfo
        var res = await showAddSubCategoryDialog({
            title: "Edit Sub Category For User Site",
            record: info,
            isEditing: true
        });
        if (res === null) return;

        setIsBusy(true);
        apiUpdateSubCategory(res, main_category_id)
            .then((data) => {
                setIsBusy(false);
                if (data === null) {
                    message.error("There's something wrong while updating a Sub Category");
                }
                let updateData = [...dataList];
                var storeIndex = updateData.findIndex(x => x.id == data.id);
                updateData.splice(storeIndex, 1, data);
                setDataList(updateData)
                setSearchList(updateData)

            })
            .catch((err) => {
                setIsBusy(false);
                message.error(err);
            });
    }
    const handleDateFilter = (startDate, endDate) => {
        if (startDate == "" || endDate == "") {
            setSearchList([...dataList])
        } else {
            const start_date = new Date(startDate + "T00:00:00");
            const end_date = new Date(endDate + "T23:59:59");
            const tmpList = dataList.filter((info) => start_date <= new Date(info.update_timestamp.replace(/ /g, "T")) && new Date(info.update_timestamp.replace(/ /g, "T")) <= end_date)
            setSearchList([...tmpList])
        }
    }
    return (
        <CommonDivWidget>
            <Spin spinning={isBusy}>
                <a><u  onClick={()=>{history.goBack()}}>Go back</u></a>
                <Row>
                    <Col>
                        <div style={{ fontFamily: 'mediumFont', padding: 20 }}>Date Filter Period : &nbsp;&nbsp;
                            <RangePicker size={'default'}
                                onChange={(e, date) => {
                                    if (date == null) {
                                        handleDateFilter("", "")
                                    } else {
                                        handleDateFilter(date[0], date[1])
                                    }

                                }} />
                        </div>
                    </Col>
                    <Col flex={'auto'}>
                        <div style={{ fontFamily: 'mediumFont', padding: 20 }}>
                            <TitleSearch
                                onSearch={handleSearch}
                                onChange={handleChange}
                                onPressEnter={handleSearch}
                            />
                        </div>
                    </Col>
                    <Col>
                        <div style={{ fontFamily: 'mediumFont', padding: 20 }}>
                            <CommonButton onClick={() => {
                                onNewSubCategory()
                            }}>New</CommonButton>
                        </div>
                    </Col>
                </Row>

                <div>
                    <TableWidget
                        dataList={searchList}
                        onDetailAction={onClickDetail}
                        onUpdateAction={onClickEdit}
                        onDeleteAction={onClickDelete}
                    />
                </div>
            </Spin>
        </CommonDivWidget>
    )
}

export default U_SubCategoryPage
